<template>
  <div>
    <b-container>
      <nav-bar :title="'Task Timer'"></nav-bar>
      <b-row>
        <b-card no-body class="border-0 w-100 pt-0" id="timer">
          <b-tabs small card>
            <b-tab title="Timer">
              <!-- {{task}} -->
              <task-detail
                :Title="task.title"
                :ProjectName="task.project"
                :type="'Timer'"
                :taskId="task.id"
              ></task-detail>
              <component
                v-bind:is="currentComponent"
                v-bind="currentProperties"
              ></component>
            </b-tab>
            <b-tab title="Stopwatch">
              <task-detail
                :Title="task.title"
                :ProjectName="task.project"
                :type="'Stop'"
                :taskId="task.id"
              ></task-detail>
              <stopwatch v-bind="currentProperties"></stopwatch>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import navBar from '@/components/atmNavBar';
import taskDetail from '@/components/Timer/atmTaskDetail';
import setTime from '@/components/Timer/atmSetTime';
import timer from '@/components/Timer/atmTimer';
import stopwatch from '@/components/Timer/atmStopwatch';
import store from '@/store';
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  data() {
    return {
      currentComponent: 'setTime',
      task: store.getters['task/getTaskId'](this.$route.params.Tid),
      hours: 0,
      minutes: 30
    };
  },
  components: {
    navBar,
    setTime,
    taskDetail,
    timer,
    stopwatch
  },
  computed: {
    ...mapGetters('timer', ['getTaskSpentTime']),
    currentProperties: function() {
      return { instance: this };
    }
  },
  methods: {
    ...mapActions('timer', ['send_total_time']),
    ...mapMutations('timer', ['saveNewTimer']),
    showMsgConfirm(timeSpent) {
      let totalTime = timeSpent + this.getTaskSpentTime(this.task.id);
      this.boxTwo = '';
      this.$bvModal
        .msgBoxConfirm('Please confirm. Did you finish this task?', {
          buttonSize: 'lg',
          okVariant: 'success',
          okTitle: 'YES, I FINISH IT',
          cancelVariant: 'danger',
          cancelTitle: 'NOT YET',
          footerClass: 'p-2',
          hideHeaderClose: false,
          noCloseOnBackdrop: true,
          centered: true
        })
        .then(value => {
          this.saveNewTimer({ task: this.task, timeSpentSeconds: totalTime });
          this.send_total_time({
            totalTime: totalTime,
            taskId: this.task.id,
            isComplete: value
          }).then(response => {
            if (response.coins) {
              this.$router.push({
                name: 'congrats',
                params: {
                  coins: response.coins,
                  points: response.points,
                  description: response.description
                },
                query: { next: 'timer-task-list' }
              });
            } else {
              this.$router.push({ name: 'timer-task-list' });
            }
          });
        })
        .catch(err => {
          // An error occurred
        });
    }
  },
  async beforeRouteEnter(to, from, next) {
    let childId = store.getters['user/userIsAParent']
      ? store.getters['user/getChildSelectedId']
      : store.getters['user/getUserId'];

    await Promise.all([
      store.dispatch('task/fetchAllTasks', { childId }),
      store.dispatch('timer/fetchTaskTime', to.params.Tid)
    ]);
    store.dispatch('task/fetchAllTasks', { childId }).then(() => {
      next();
    });
  }
};
</script>

<style>
#timer .nav-link {
  padding: 0.5rem 0 !important;
  text-align: center !important;
}
#timer .nav-tabs .nav-item {
  width: 50% !important;
}
#timer .card-header {
  padding: 0 !important;
}
#timer .card-header-tabs {
  margin-right: 0 !important;
  margin-bottom: 0 !important;
  margin-left: 0 !important;
  border-bottom: 0 !important;
}
#timer .nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #383c6b !important;
  background-color: #fff !important;
  border-color: #dee2e6 #dee2e6 #fff !important;
  height: 100%;
}
#timer .card-body {
  padding: 0 5px;
}
</style>
